module.exports = __webpack_public_path__ + "static/img/conveyor-belt-mk-4_256.e72ca79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-belt-mk-4_256.png
// module id = pIO0
// module chunks = 0